import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=1bea8086&"
import script from "./CategoryDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports